import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M9.05 38.95q-.45-.45-.45-1.05 0-.6.45-1.05L32.9 13H19.7q-.65 0-1.075-.425-.425-.425-.425-1.075 0-.65.425-1.075Q19.05 10 19.7 10h16.8q.65 0 1.075.425Q38 10.85 38 11.5v16.8q0 .65-.425 1.075-.425.425-1.075.425-.65 0-1.075-.425Q35 28.95 35 28.3V15.1L11.15 38.95q-.45.45-1.05.45-.6 0-1.05-.45Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }